var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center-nav'),_vm._v(" "),(_vm.isBasic)?_c('slider-menu',{attrs:{"menuData":_vm.menuDataBasic,"type":2}}):_c('slider-menu',{attrs:{"menuData":_vm.menuData,"type":2}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8d6448","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pc/official/Index.vue
// module id = null
// module chunks = 